import { render, staticRenderFns } from "./GDateTime.vue?vue&type=template&id=51081de2"
import script from "./GDateTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./GDateTime.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports